//Boulogne

import imgA from "../Images/queirozImages/SELECTION SITE/Boulogne/20200618_133929.jpg";
import imgB from "../Images/queirozImages/SELECTION SITE/Boulogne/20200618_144307.jpg";
import imgC from "../Images/queirozImages/SELECTION SITE/Boulogne/DSCN1656.JPG";
import imgD from "../Images/queirozImages/SELECTION SITE/Boulogne/DSCN1663.JPG";
import imgE from "../Images/queirozImages/SELECTION SITE/Boulogne/DSCN1672.JPG";
import imgF from "../Images/queirozImages/SELECTION SITE/Boulogne/DSCN1687.JPG";

//Tour Maubourg

import imgAA from "../Images/queirozImages/SELECTION SITE/Tour-Maubourg/001.jpg";
import imgBB from "../Images/queirozImages/SELECTION SITE/Tour-Maubourg/019-b.jpg";
import imgCC from "../Images/queirozImages/SELECTION SITE/Tour-Maubourg/048.jpg";
import imgDD from "../Images/queirozImages/SELECTION SITE/Tour-Maubourg/061.jpg";
import imgEE from "../Images/queirozImages/SELECTION SITE/Tour-Maubourg/066.jpg";
import imgFF from "../Images/queirozImages/SELECTION SITE/Tour-Maubourg/070.jpg";
import imgGG from "../Images/queirozImages/SELECTION SITE/Tour-Maubourg/125.jpg";


//Montmartre

import imgJJ from "../Images/queirozImages/SELECTION SITE/Montmartre/CLICHY (28 sur 176).jpg";
import imgKK from "../Images/queirozImages/SELECTION SITE/Montmartre/CLICHY (32 sur 176).jpg";
import imgLL from "../Images/queirozImages/SELECTION SITE/Montmartre/CLICHY (36 sur 176).jpg";
import imgMM from "../Images/queirozImages/SELECTION SITE/Montmartre/CLICHY (87 sur 176).jpg";
import imgNN from "../Images/queirozImages/SELECTION SITE/Montmartre/CLICHY (88 sur 176).jpg";
import imgOO from "../Images/queirozImages/SELECTION SITE/Montmartre/CLICHY (97 sur 176).jpg";
import imgPP from "../Images/queirozImages/SELECTION SITE/Montmartre/CLICHY (132 sur 176).jpg";
import imgQQ from "../Images/queirozImages/SELECTION SITE/Montmartre/CLICHY (157 sur 176).jpg";
import imgRR from "../Images/queirozImages/SELECTION SITE/Montmartre/CLICHY (168 sur 176).jpg";
import imgSS from "../Images/queirozImages/SELECTION SITE/Montmartre/CLICHY (172 sur 176).jpg";
import imgTT from "../Images/queirozImages/SELECTION SITE/Montmartre/CLICHY (157 sur 176).jpg";
import imgWW from "../Images/queirozImages/SELECTION SITE/Montmartre/CLICHY (157 sur 176).jpg";
import imgUU from "../Images/queirozImages/SELECTION SITE/Montmartre/TERRASSE 104 CLICHY (40 sur 53).jpg";
import imgVV from "../Images/queirozImages/SELECTION SITE/Montmartre/TERRASSE 104 CLICHY (43 sur 53).jpg";





//Marechal Foch/Saint Cloud

import imgAAA from "../Images/queirozImages/SELECTION SITE/Saint-Cloud/IMG_0285.JPG";
import imgAAB from "../Images/queirozImages/SELECTION SITE/Saint-Cloud/IMG_0286.JPG";
import imgAAC from "../Images/queirozImages/SELECTION SITE/Saint-Cloud/IMG_0291.JPG";
import imgAAD from "../Images/queirozImages/SELECTION SITE/Saint-Cloud/IMG_0294.JPG";
import imgAAE from "../Images/queirozImages/SELECTION SITE/Saint-Cloud/IMG_0295.JPG";
import imgAAF from "../Images/queirozImages/SELECTION SITE/Saint-Cloud/IMG_0298.JPG";

//Scheffer



import imgAAG from "../Images/queirozImages/SELECTION SITE/Scheffer/016.jpg";
import imgAAH from "../Images/queirozImages/SELECTION SITE/Scheffer/025.jpg";
import imgAAI from "../Images/queirozImages/SELECTION SITE/Scheffer/047.jpg";
import imgAAJ from "../Images/queirozImages/SELECTION SITE/Scheffer/063.jpg";
import imgAAK from "../Images/queirozImages/SELECTION SITE/Scheffer/110.jpg";
import imgAAL from "../Images/queirozImages/SELECTION SITE/Scheffer/132.jpg";
import imgAAM from "../Images/queirozImages/SELECTION SITE/Scheffer/152.jpg";
import imgAAN from "../Images/queirozImages/SELECTION SITE/Scheffer/189.jpg";

export const PicsMontmartre = [
  {
    id: 1,
    img: imgJJ,
  },
  {
    id: 2,
    img: imgKK,
  },
  {
    id: 3,
    img: imgLL,
  },
  {
    id: 4,
    img: imgMM,
  },
  {
    id: 5,
    img: imgNN,
  },
  {
    id: 7,
    img: imgOO,
  },
  {
    id: 8,
    img: imgPP,
  },
  {
    id: 9,
    img: imgQQ,
  },
  {
    id: 10,
    img: imgRR,
  },
  {
    id: 11,
    img: imgSS,
  },
  {
    id: 12,
    img: imgTT,
  },
  {
    id: 13,
    img: imgWW,
  },
  {
    id: 14,
    img: imgVV,
  },
];

export const PicsTourMaubourg = [
  {
    id: 1,
    img: imgAA,
  },
  {
    id: 2,
    img: imgBB,
  },
  {
    id: 3,
    img: imgCC,
  },
  {
    id: 4,
    img: imgDD,
  },
  {
    id: 5,
    img: imgEE,
  },
  {
    id: 6,
    img: imgFF,
  },
  {
    id: 7,
    img: imgGG,
  },

];

export const PicsBoulogne = [
  {
    id: 1,
    img: imgA,
  },
  {
    id: 2,
    img: imgB,
  },
  {
    id: 3,
    img: imgC,
  },
  {
    id: 4,
    img: imgD,
  },
  {
    id: 5,
    img: imgE,
  },
  {
    id: 6,
    img: imgF,
  },
];


export const PicsOperation = [
  {
    id: "A",
    img: imgFF,
    imageLink: "Operations/TourMaubourg",
    name: "Tour-Maubourg",
  },
  {
    id: "B",
    img: imgUU,
    imageLink: "Operations/Montmartre",
    name: "Montmartre",
  },
  
  {
    id: "D",
    img: imgA,
    imageLink: "Operations/Boulogne",
    name: "Boulogne",
  },
  {
    id: "E",
    img: imgAAA,
    imageLink: "/Operations/SaintCloud",
    name: "Saint Cloud",
  },
  {
    id: "F",
    img: imgAAL,
    imageLink: "Operations/Scheffer",
    name: "Scheffer",
  },
];


export const PicsSaintCloud = [
  {
    id: 1,
    img: imgAAA,
  },
  {
    id: 2,
    img: imgAAB,
  },
  {
    id: 3,
    img: imgAAC,
  },
  {
    id: 4,
    img: imgAAD,
  },
  {
    id: 5,
    img: imgAAE,
  },
  {
    id: 6,
    img: imgAAF,
  },
];


export const PicsScheffer = [
  {
    id: 1,
    img: imgAAG,
  },
  {
    id: 2,
    img: imgAAH,
  },
  {
    id: 3,
    img: imgAAI,
  },
  {
    id: 4,
    img: imgAAJ,
  },
  {
    id: 5,
    img: imgAAK,
  },
  {
    id: 6,
    img: imgAAL,
  },
  {
    id: 7,
    img: imgAAM,
  },
  {
    id: 8,
    img: imgAAN,
  },
];